/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 21st 2022, 7:10:58 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { TaskActionsIcon } from "theme/icons";
import { COLORSCHEME } from "theme/styles";

interface ResultStatementProps {
  resultStatement?: React.ReactNode;
}

export const ResultStatement = ({ resultStatement }: ResultStatementProps) => (
  <Grid container>
    <Grid item xs={12} sx={{ padding: 2 }}>
      <Stack direction="row" spacing={4}>
        <TaskActionsIcon height={50} width={50} />
        <Typography color={COLORSCHEME.success} variant="h5">
          {resultStatement}
        </Typography>
      </Stack>
    </Grid>
  </Grid>
);
